<template>
  <b-container class="home">
    <b-row v-if="result === 'success'" class="justify-content-center marginaltop">
      <b-col cols="2">
        <b-img fluid src="https://checkoutshopper-test.adyen.com/checkoutshopper/images/components/success.gif"></b-img>
      </b-col>
    </b-row>
    <b-row v-if="result === 'success'" class="justify-content-center marginaltop text-center">
      <b-col cols="6">
        <h4> Paiement accepté !</h4>
      </b-col>
    </b-row>
    <b-row v-if="result === 'error'" class="justify-content-center marginaltop">
      <b-col cols="2">
        <b-img fluid src="https://checkoutshopper-test.adyen.com/checkoutshopper/images/components/error.gif"></b-img>
      </b-col>
    </b-row>
    <b-row v-if="result === 'error'" class="justify-content-center marginaltop text-center">
      <b-col cols="6">
        <h4> Paiement refusé.</h4>
      </b-col>
    </b-row>
    <b-modal ref="firstPayment" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Welcome to Quanteec</h3>
      </div>
      <div class="d-block text-center">
        <p>Free-tier limitations have been removed. A new domain name with your full ressources will be created within 24h.</p>
      </div>
      <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="mswarning" block @click="reloadPage();hideModal('firstPayment');">Close</b-btn>
      </b-row>
    </b-modal>
  </b-container>
</template>

<script>
import PaymentService from '@/services/payment.service';
let paymentService = new PaymentService();
export default {
  name: 'redirect',
  data() {
      return {
          redirectResult: '',
          type: '',
          resultCode: '',
          result: ''
      }
  },
  mounted() {
    this.redirectResult = this.$route.query['redirectResult'];
    this.type = this.$route.query['type'];
    this.resultCode = this.$route.query['resultCode'];
    if (!!this.redirectResult) {
      this.makeDetailsCall({details: {redirectResult: this.redirectResult}})
        .then((result) => {
          this.result = "success";
          if (this.$auth.getMyUser().client_infos[0].price === 0 || this.$auth.getMyUser().client_infos[0].oldAccount.price === 0) {
            this.showModal('firstPayment');
          }
        })
        .catch((err) => {
          this.result = "error";
        })
    }
  },
  methods: {
    makeDetailsCall(data) {
          let self = this;
          return new Promise((done, reject) => {
              paymentService.postPaymentDetails(data, self.$auth.token()).then((result) => {
                done(result);
              }).catch(err => {
                reject(err);
              })
              
          }) 
      },
      showModal(ref) {
        this.$refs[ref].show();
      },
      hideModal(ref) {
        this.$refs[ref].hide();
      },
      reloadPage() {
          setTimeout(function() {
                window.location.reload();
            }, 3000);
      }
  }
}
</script>